// extracted by mini-css-extract-plugin
module.exports = {"mobileBgPosition":"FooterBanner_mobileBgPosition__chsx3"};